<mat-card style="height: 100%; max-height: 400px;">
  <mat-form-field appearance="outline" color="accent" style="width: 100%; margin-bottom: 8px;">
    <mat-label>Search Parts</mat-label>
    <input matInput
      [(ngModel)]="searchTerm"
      (ngModelChange)="getFilteredParts()"

      placeholder="Enter part name" />
    @if (searchTerm) {
      <button matSuffix mat-icon-button aria-label="Clear" (click)="searchTerm=''; getFilteredParts()">
        <mat-icon>close</mat-icon>
      </button>
    }
  </mat-form-field>
  <mat-accordion style="overflow-y: auto;">
    @for (part of pagedParts; track part.Part) {
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>
            {{ part.Part }}
          </mat-panel-title>
        </mat-expansion-panel-header>
        <mat-list>
          @for (quoteId of part.QuoteUnits; track quoteId) {
            <mat-list-item>
              <a [routerLink]="['/sales/quote', quoteId]" class="green" style="cursor: pointer;">
                Quote ID: {{ quoteId }}
              </a>
            </mat-list-item>
          }
        </mat-list>
      </mat-expansion-panel>
    }
  </mat-accordion>
  <mat-paginator [length]="filteredParts.length"
                 [pageSize]="10"
                 [pageSizeOptions]="[10]"
                 (page)="onPageChange($event)">
  </mat-paginator>
  @if (pagedParts.length === 0) {
    <div style="padding: 1rem; color: #888;">
      No parts found.
    </div>
  }
</mat-card>
